import { render } from "./BasePanel.vue?vue&type=template&id=6715369f&scoped=true&ts=true"
import script from "./BasePanel.vue?vue&type=script&lang=ts"
export * from "./BasePanel.vue?vue&type=script&lang=ts"

import "./BasePanel.vue?vue&type=style&index=0&id=6715369f&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6715369f"]])

export default __exports__